import { String2datePipe } from './string2date/string2date.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    String2datePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    String2datePipe
  ]
})
export class SharedPipesModule { }
